const fieldNames = {
  NAME: 'name',
  PATH: 'path',
  HTML_LOCALE: 'htmlLocale',
  DISPLAY_IN_NAVIGATION: 'displayInNavigation',
  PASSWORD: 'password',
  TITLE: 'title',
  SAME_AS_PAGE_NAME: 'sameAsPageName',
  DISPLAY_BUSINESS_NAME: 'displayBusinessName',
  PREVENT_INDEXING: 'preventIndexing',
  DESCRIPTION: 'description',
  KEYWORDS: 'keywords',
  HEAD_CODE: 'headCode',
  HEADER_CODE: 'headerCode',
  FOOTER_CODE: 'footerCode',
};

const FIELD_NAMES_IN_GENERAL_TAB = [
  fieldNames.NAME,
  fieldNames.PATH,
  fieldNames.HTML_LOCALE,
  fieldNames.DISPLAY_IN_NAVIGATION,
  fieldNames.PASSWORD,
];

const FIELD_NAMES_IN_SEO_TAB = [
  fieldNames.TITLE,
  fieldNames.SAME_AS_PAGE_NAME,
  fieldNames.DISPLAY_BUSINESS_NAME,
  fieldNames.PREVENT_INDEXING,
  fieldNames.DESCRIPTION,
  fieldNames.KEYWORDS,
];

const FIELD_NAMES_IN_CUSTOM_CODE_TAB = [
  fieldNames.HEAD_CODE,
  fieldNames.HEADER_CODE,
  fieldNames.FOOTER_CODE,
];

export default fieldNames;
export { FIELD_NAMES_IN_GENERAL_TAB, FIELD_NAMES_IN_SEO_TAB, FIELD_NAMES_IN_CUSTOM_CODE_TAB };
